import React, {Component} from "react";
import {Form, Input,Select,Checkbox} from "antd";
const { TextArea } = Input;
const { Option } = Select;

class DifferentSerialNumber extends Component{
    render (){
        return <div>
            <Form.Item
                label="Serial Number"
                name={'serialNumbers'}
                rules={[{ required: true}]}
            >
                <Input />
            </Form.Item>
            <p style={{color:'#dc291e',marginLeft:'46%',display:this.props.InvoiceClaimMsg?'block':'none'}}>The Serial number is linked to different customer</p>             
            <Form.Item
                label="DOA Period Confirmation Number"
                name={'doaConfirmNo'}
                rules={[{ required: true}]}
            >
                <Input maxLength={10} />
            </Form.Item>
            <Form.Item
            label="BIOS Password"
            name={'biosPassword'}
            rules={[{ required:false}]}
            >
                <Input maxLength={20} />
            </Form.Item>
                
        </div>
    }

}

export default DifferentSerialNumber;